module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "events"
  }, [_c('filters', {
    attrs: {
      "calendarApi": _vm.calendarApi
    },
    on: {
      "changeFilters": _vm.filtersChanged
    }
  }), _vm._v(" "), _c('more', {
    attrs: {
      "calendarApi": _vm.calendarApi
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-27e28a84", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27e28a84"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/Events.vue
// module id = 2742
// module chunks = 0